import PropTypes                from "prop-types";
import React                    from "react";
import FeedPostFooter           from "./FeedPostFooter";
import Flux                     from "../../flux/Flux";
import FeedPostAlbum            from "./FeedPostAlbum";
import FeedPostVideo            from "./FeedPostVideo";
import FeedPostHeader           from "./FeedPostHeader";
import { getFormattedDate }     from "../Helper/DateHelper";
import { getTimeFromSeconds,
	     postClipType,
	     postType,
	     postPhotoType,
		 postCommentType,
		 FREE_CONTENT }         from "./FeedHelper";
import { getCommonTranslation } from '../../utils/TranslationHelper';
import TileBadgesList           from '../TileGrid/Badge/TileBadgesList';
import FeedPostNeedAction       from "./FeedPostNeedAction";
import {getUrlParam}            from "../../utils/CommonUtils";
import FeedPostBuyOverlay       from "./FeedPostBuyOverlay";
import FeedPostNeedsTippingGoal from "./FeedPostNeedsTippingGoal";
class FeedPost extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			hasLiked:    this.props.guestState ? this.props.guestState.liked : false,
			likes:       this.props.likes,
			tippingGoal: this.props.tippingGoal,
		};

		this.postRef;

		this.hasViewed = this.props.guestState && this.props.guestState.viewed;

		this.toggleLikeFunc   = this.toggleLikeFunc.bind(this);

		this.observer = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && Flux.Guest.isLoggedIn()) {
				!this.hasViewed && Flux.Feed.viewedPost(this.props.id, this.props.feedType, () => {
					this.hasViewed = true;
				});
			}
		});
	}

	componentDidMount() {
		Flux.Feed.addLikeChangeListener(this.toggleLikeFunc);
		if (this.postRef && !this.props.isOverlay) {
			this.observer.observe(this.postRef);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.likes !== this.props.likes) {
			this.setState({likes: this.props.likes, hasLiked: this.props.guestState && this.props.guestState.liked});
		}
		if (prevProps.tippingGoal !== this.props.tippingGoal) {
			// wait for tipping goal animation
			setTimeout(function() {
				this.setState({tippingGoal: this.props.tippingGoal});
			}.bind(this), 1500);
		}
	}

	componentWillUnmount() {
		Flux.Feed.removeLikeChangeListener(this.toggleLikeFunc);
	}

	getHeader() {
		switch (this.props.type) {
			case Flux.Constants.Feed.Types.CLIP:
			case Flux.Constants.Feed.Types.HOT_CLIP:
			case Flux.Constants.Feed.Types.FP_HOT_CLIP:
				return (
					<FeedPostHeader {...this.props} isRecommended={false}>
						<div className="feed-info feed-info--gray">
							<span>{getFormattedDate(this.props.published || this.props.created)}</span>
							<span>{getTimeFromSeconds(this.props.clip.length)}</span>
							<span>
								<i className="icon -icon-eyes-full" /> {this.props.views}
							</span>
						</div>
					</FeedPostHeader>
				);
			case Flux.Constants.Feed.Types.PHOTOS:
			case Flux.Constants.Feed.Types.PHOTO_GALLERY:
			case Flux.Constants.Feed.Types.FP_PHOTO_GALLERY:
				const photos = this.props.photos;
				return (
					<FeedPostHeader {...this.props} isRecommended={false}>
						<div className="feed-info feed-info--gray">
							<span>{getFormattedDate(this.props.published || this.props.created)}</span>
							{photos.length !== 1 && (
								<span>
									{photos.length} {photos.length !== 1 ? getCommonTranslation('images') : getCommonTranslation('image')}
								</span>
							)}
						</div>
					</FeedPostHeader>
				);
			case Flux.Constants.Feed.Types.CONTEST:
			case Flux.Constants.Feed.Types.TEXT:
				return (
					<FeedPostHeader {...this.props} isRecommended={false}>
						<div className="feed-info feed-info--gray">
							<span>{getFormattedDate(this.props.published || this.props.created)}</span>
						</div>
					</FeedPostHeader>
				);
		}
	}

	isBought(isBought) {
		return isBought || [...FREE_CONTENT].includes(this.props.type); //need no bought
	}

	getItem() {
		const needBuy = this.needBuy();

		switch (this.props.type) {
			case Flux.Constants.Feed.Types.CLIP:
			case Flux.Constants.Feed.Types.HOT_CLIP:
			case Flux.Constants.Feed.Types.FP_HOT_CLIP:
				return <FeedPostVideo {...this.props} needBuy={needBuy} tippingGoal={this.state.tippingGoal} />;
			case Flux.Constants.Feed.Types.PHOTOS:
			case Flux.Constants.Feed.Types.PHOTO_GALLERY:
			case Flux.Constants.Feed.Types.FP_PHOTO_GALLERY:
            case Flux.Constants.Feed.Types.CONTEST:
				if (this.props.photos.length  < 1) {
					return null;
				}
				return <FeedPostAlbum {...this.props} needBuy={needBuy} tippingGoal={this.state.tippingGoal} />;
			case Flux.Constants.Feed.Types.TEXT:
				return <div></div>;
		}
	}

	toggleLikeFunc(id) {
		if (id !== this.props.id) {
			return;
		}
		const liked = this.state.hasLiked;

		if (this.props.type !== Flux.Constants.Feed.Types.TEXT) {
			if (!liked) {
				this.likeRef.classList.add('feed-post__like--active');
				setTimeout(() => {
					this.likeRef.classList.remove('feed-post__like--active');
				}, 500);
			} else {
				this.dislikeRef.classList.add('feed-post__like--active');
				setTimeout(() => {
					this.dislikeRef.classList.remove('feed-post__like--active');
				}, 500);
			}
		}

		const trigger = () => {
			setTimeout(() => {
				Flux.Feed.triggerUpdatePost(id);
			}, 100);
		};

		if (liked) {
			Flux.Feed.unlikePost(this.props.id, () => {
					trigger();
			});
		} else {
			Flux.Feed.likePost(this.props.id, this.props.feedType, () => {
					trigger();
			});
		}
	}

	setPostRef(ref) {
		this.postRef = ref;
		if (this.postRef) {
			this.observer.observe(this.postRef);
			if (this.props.isMobile && this.props.id === getUrlParam('postId') &&  this.props.feedType === Flux.Constants.Feed.FeedType.PROFILE) {
				window.scrollTo({top: ref.getBoundingClientRect().top - 120});
			}
			if (this.props.feedType !== Flux.Constants.Feed.FeedType.PROFILE && (this.props.id === Flux.Feed.getSelectedPostId(this.props.feedType))) {
				setTimeout(() => {
					ref.scrollIntoView({
						block: "start",
					});
					Flux.Feed.setSelectedPostId(null, this.props.feedType);
				}, 0);
			}
		}
	}

	needBuy(){
		return (Flux.Guest.isLoggedIn() && this.props.guestState) && this.props.paidContent && !this.props.guestState.bought;
	}

	getBadges() {
		if(!(Flux.Guest.isLoggedIn() && this.props.paidContent) && !this.state.tippingGoal) {
			return null;
		}
		const needBuying = Flux.Guest.isLoggedIn() && this.props.guestState ? !this.props.guestState.bought : true;

		return <TileBadgesList
				data={{
					isOver18Content: this.props.fsk === "FSK18",
					price: this.props.priceCoins,
					needBuying,
					isTippingGoal: this.state.tippingGoal
				}}
				isMobile={this.props.isMobile}
				showPremium={false}
				showPrice={false}
			/>;

	}

	needAvs() {
		switch (this.props.type) {
			case Flux.Constants.Feed.Types.CLIP:
			case Flux.Constants.Feed.Types.HOT_CLIP:
			case Flux.Constants.Feed.Types.FP_HOT_CLIP:
				return this.props.clip && this.props.clip.avsRequired;
			case Flux.Constants.Feed.Types.PHOTOS:
			case Flux.Constants.Feed.Types.PHOTO_GALLERY:
			case Flux.Constants.Feed.Types.FP_PHOTO_GALLERY:
				return this.props.photos && this.props.photos.find(photo => photo.avsRequired);
			default:
				return false;
		}
	}

	render() {
		const item  = this.getItem();
		if (!item) {
			console.log('!item');
			return null;
		}
		const isComment = this.props.overlayType === Flux.Constants.Feed.OverlayTypes.COMMENTS;
		const needAvs = (!Flux.Guest.hasAvs() && this.needAvs());
		const needsTippingGoal = this.state.tippingGoal && !this.state.tippingGoal.achieved;
		const showPaidAction = ((this.props.paidContent || (this.props.tippingGoal && !this.props.tippingGoal.achieved)) && (!Flux.Guest.isLoggedIn() || needAvs));

		const model = {
				id: 0,
				name: "VISIT-X World",
				avatar: {
					url: '/assets/img/visitxworld.png'
				}
			};

		const innerClassList = [];
		const classList      = [];
		innerClassList.push("feed__post");
		this.props.isOverlay && classList.push("feed__post--contents");
		!this.props.isOverlay && this.props.isRecommended && classList.push("feed__post--recommended");
		this.props.isOverlay ? innerClassList.push("feed__post--overlay") : innerClassList.push("feed__post--normal");
		this.props.isOverlay && !this.props.isMobile && innerClassList.push("feed__post--overlay-desktop");
		this.props.isTablet && !this.props.isLandscape && innerClassList.push("feed__post--tablet");
		this.props.isTablet && !this.props.isLandscape && isComment && innerClassList.push("feed__post--tablet-comment");
		((this.props.isOverlay && this.props.type === Flux.Constants.Feed.Types.TEXT) || isComment) && innerClassList.push("feed__post--overlay-comments");

		return (<div className={classList.join(' ')} ref={ref => this.setPostRef(ref)}>
					{!this.props.isOverlay && this.props.isRecommended && <FeedPostHeader feedType={this.props.feedType} model={model} isRecommended={true}><div className="feed-info feed-info--gray"><span>{getCommonTranslation('recommends')}</span></div></FeedPostHeader>}
					<article className={innerClassList.join(' ')}>
						{(this.props.isMobile || this.props.isTablet) && this.props.isOverlay ? (isComment && this.getHeader()) : this.getHeader()}
						<div className="feed-content">
							{(this.props.isTablet || this.props.isMobile) && this.props.isOverlay ? (!isComment && item) : item}
							{!this.props.isOverlay && this.getBadges()}
							{!showPaidAction && this.needBuy() && <FeedPostBuyOverlay actor={this.props.model} title={this.props.title} text={this.props.text} price={this.props.priceCoins} postId={this.props.id} type={this.props.type} />}
							{showPaidAction && (!needsTippingGoal || !Flux.Guest.isLoggedIn()) && <FeedPostNeedAction actorId={this.props.model.id} showBadge={this.props.fsk === "FSK18"} isOverlay needAvs={needAvs} tippingGoal={this.state.tippingGoal} />}
							{needsTippingGoal && <FeedPostNeedsTippingGoal {...this.props} needAvs={needAvs} />}
							<div className="feed-post__like" ref={ref => this.likeRef = ref}>
								<i className="icon -icon-like-full"></i>
							</div>
							<div className="feed-post__like" ref={ref => this.dislikeRef = ref}>
								<i className="icon -icon-like-line"></i>
							</div>
						</div>
						{(this.props.isTablet || this.props.isMobile) && !this.props.isLandscape && this.props.isOverlay ? (isComment && <FeedPostFooter {...this.props} hasLiked={this.state.hasLiked} />) : <FeedPostFooter {...this.props} hasLiked={this.state.hasLiked} likes={this.state.likes} />}
					</article>
				</div>);
	}
}
FeedPost.propTypes = {
	isOverlay:              PropTypes.bool,
	overlayType:            PropTypes.string,
	imageId:                PropTypes.string,
	feedType:               PropTypes.string,
	isMobile:               PropTypes.bool,
	isTablet:               PropTypes.bool,
	isLandscape:            PropTypes.bool,
	isRecommended:          PropTypes.bool,
	initFavorite:           PropTypes.bool,
	isTabletOverlayComment: PropTypes.bool,
	comments:               PropTypes.shape(postCommentType),
	clip:                   PropTypes.shape(postClipType),
	photos:                 PropTypes.arrayOf(PropTypes.shape(postPhotoType)),
	...postType,
};

FeedPost.defaultProps = {
	isOverlay:    false,
	initFavorite: false,
	isTablet:     false,
	isLandscape:  false,
	isTableOverlayComment:       false,
};


export default FeedPost;
